import { AnimationButton } from "../../Animation";

const SubMenu = () => {
  return (
    <div className="framer-poqdm0" data-framer-name="Get template">
      <div className="framer-15ydghx-container">
        <AnimationButton>
          <a
            className="framer-bnygp framer-lsiydu framer-v-lsiydu framer-86q8yf bg-[var(--token-dfd29766-9b54-40dd-9398-e62b74c1aefb,rgb(34,34,34))] rounded-[8px]"
            data-framer-name="Button State 1"
            data-highlight="true"
            href="https://build.codeblaze.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="framer-1nhaedp bg-gradient-radial from-[#70befa] to-transparent rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-lg"
              data-framer-name="Stroke"
            ></div>
            <div
              className="framer-1lkeuwd bg-[#161616] rounded-tl-md rounded-tr-md rounded-bl-md rounded-br-md"
              data-framer-name="Fill"
            ></div>
            <div
              className="framer-1x509j2 outline-none flex flex-col justify-start flex-shrink-0 text-white link text-blue-500 underline"
              data-framer-component-type="RichTextContainer"
            >
              <a href="https://build.codeblaze.ai" target="_blank">
                <h4 className="framer-text font-[Switzer, sans-serif] text-white text-[14px] tracking-normal">
                  <span
                    data-text-fill="true"
                    className="framer-text bg-gradient-to-r from-white to-[#70befa]"
                  >
                    Sign In
                  </span>
                </h4>
              </a>
            </div>
          </a>
        </AnimationButton>
      </div>
    </div>
  );
};

export default SubMenu;
